import React, { Component } from "react";
import Header from "../../layout/Header";
import image1 from "../../../images/Bestpractices/Implant.jpeg";
// Import 5 placeholder images for the photo gallery (replace with actual paths)
import photo1 from "../../../images/Planetary/photo1.jpeg";
import photo2 from "../../../images/Planetary/photo2.jpeg";
import photo3 from "../../../images/Planetary/photo3.jpeg";
import photo4 from "../../../images/Planetary/photo4.jpeg";
import photo5 from "../../../images/Planetary/photo5.jpeg";

export class PlanetaryHealthStudentClub extends Component {
  render() {
    return (
      <div className="site-main">
        <Header />
        {/* Page Title */}
        <div className="ttm-page-title-row bestpractices-banner">
          <div className="container-xl">
            <div className="row">
              <div className="col-md-12">
                <div className="title-box text-center">
                  <div className="page-title-heading card_box">
                    <h4 className="title" style={{ color: "white" }}>
                      Planetary Health Student Club
                    </h4>
                    <div className="ttm-color-home">
                      <span>
                        <a
                          className="ttm-color-home"
                          title="Homepage"
                          href={process.env.PUBLIC_URL + "/"}
                        >
                          <i className="ti ti-home" />
                            Home
                        </a>
                      </span>
                      <span className="ttm-bread-sep">  : :  </span>
                      <span>VSDCH</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* Page Title End */}

        {/* About Section */}
        <section className="ttm-row about-services-section clearfix">
          <div className="container-xl">
            <div className="row align-items-center">
              <div className="col-lg-12">
                <div className="section-title with-desc text-center clearfix">
                  <div className="title-header">
                    <h2 className="title">About Us</h2>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <div className="res-991-mt-30">
                  <div className="section-title with-desc clearfix">
                    <div className="title-header">
                      <h2 className="title">
                        Planetary Health <span>Student Club</span>
                      </h2>
                    </div>
                    <div className="title-desc">
                      <p className="text-justify">
                        Welcome to Planetary Health Student Club, the first
                        student club established in V. S. Dental College and
                        Hospital. Established on 21st November 2022, we are a
                        group of highly motivated and committed students across
                        the academic years of V.S. Dental College and Hospital
                        dedicated to achieving campus awareness regarding
                        climate change, planetary health, health implications
                        including oral health and bring sustainable practices in
                        Dentistry.
                      </p>
                      <p>
                        Planetary health is a solutions-oriented,
                        transdisciplinary field and social movement focused on
                        analysing and addressing the impacts of human
                        disruptions to Earth’s natural systems on human health
                        and all life on Earth.
                      </p>
                      <p>
                        The growing concern regarding the unfortunate health of
                        our planet has urged leaders from across the globe and
                        disciplines to take action to achieve a comprehensive
                        shift in how human beings interact with each other and
                        Nature.
                      </p>
                      <p>
                        <strong>Climate Change is here and it’s real.</strong>
                        <br />
                        Climate crisis is a health crisis; as Oral health care
                        professionals, let's do our part to promote, mobilize,
                        contribute, and lead in the global climate movement.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* About Section End */}

        {/* Aim Section */}
        <section className="ttm-row about-services-section clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title with-desc text-center clearfix">
                  <div className="title-header">
                    <h2 className="title">
                      Our <span>Aim</span>
                    </h2>
                  </div>
                  <div className="title-desc">
                    <p className="text-justify">
                      Our Club aims to encourage and engage the youth to join
                      hands in creating awareness and innovative solutions to
                      tackle the climate crisis from an oral health perspective.
                      Because youth action makes a difference!
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Aim Section End */}

        {/* Ongoing Activities Section */}
        <section className="ttm-row about-services-section clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title with-desc text-center clearfix">
                  <div className="title-header">
                    <h2 className="title">
                      On-Going <span>Activities</span>
                    </h2>
                  </div>
                  <div className="title-desc">
                    <p className="text-justify">
                      Since its initiation in November 2022, the club's
                      leadership has been dedicated to establishing a robust
                      administration and structure, executing various
                      activities:
                    </p>
                    <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15 text-justify">
                      <li>
                        <i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Successfully implemented 'Sustainability Guidelines'
                          for college activities and meetings at graduation
                          ceremonies and two college cultural programs.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Creation of patient education material and dedicated
                          magazine inclusive of planetary health and climate
                          change related articles.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Campus clean-up drive followed by multiple
                          reinforcement sessions to educate regarding waste
                          management.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Planetary Health Lecture Series with the completion of
                          the first lecture on orchids conservation.
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Initiation of the pilot for the Dental Planetary
                          Health Report Card.
                        </span>
                      </li>
                    </ul>
                    <p className="text-justify pt-15">
                      Stay tuned for more updates, do support our students, and
                      follow the PHSC Instagram page!
                      <a
                        href="https://www.instagram.com/phsc_vsdch"
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        Planetary Health Student Club (@phsc_vsdch)
                      </a>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Ongoing Activities Section End */}

        {/* Photo Gallery Section */}
        <section className="ttm-row about-services-section clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title with-desc text-center clearfix">
                  <div className="title-header">
                    <h2 className="title">
                      Photo <span>Gallery</span>
                    </h2>
                  </div>
                </div>
                <div className="row">
                  {[photo5, photo2, photo3, photo4, photo1].map(
                    (photo, index) => (
                      <div className="col-md-4 col-sm-6" key={index}>
                        <div className="ttm_single_image-wrapper text-sm-center mb-4">
                          <img
                            className="img-fluid"
                            src={photo}
                            alt={`Planetary Health Photo ${index + 1}`}
                            title={`Planetary Health Photo ${index + 1}`}
                          />
                        </div>
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Photo Gallery Section End */}

        {/* Acknowledgement Section */}
        <section className="ttm-row about-services-section clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title with-desc text-center clearfix">
                  <div className="title-header">
                    <h2 className="title">Acknowledgement</h2>
                  </div>
                  <div className="title-desc">
                    <p className="text-justify">
                      The club places on record its gratitude to the Principal
                      Dr. Rajkumar G.C for the support. The club would not have
                      existed without the initiation and guidance from Dr. Sushi
                      Kadanakuppe who is the Faculty Lead for the club. We are
                      also grateful to the valuable guidance of our faculty
                      mentors, Dr. Suma N. K and Mrs. Savitha Rao.
                    </p>
                    <p className="text-justify">
                      With kind regards from our team at Planetary Health
                      Student Club (PHSC)
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Acknowledgement Section End */}

        {/* Why Join Us Section */}
        <section className="ttm-row about-services-section clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title with-desc text-center clearfix">
                  <div className="title-header">
                    <h2 className="title">
                      Why <span>Join Us?</span>
                    </h2>
                  </div>
                  <div className="title-desc">
                    <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15 text-justify">
                      <li>
                        <i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          International Exposure
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Networking and Self-Development
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-arrow-circle-right ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          Boost your CV/Profile
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* Why Join Us Section End */}

        {/* Team Section */}
        <section className="ttm-row about-services-section clearfix">
          <div className="container-xl">
            <div className="row">
              <div className="col-lg-12">
                <div className="section-title with-desc text-center clearfix">
                  <div className="title-header">
                    <h2 className="title">
                      Planetary Health Student Club <span>Founding Team</span>
                    </h2>
                  </div>
                  <div className="title-desc">
                    <ul className="ttm-list ttm-list-textsize-medium ttm-list-style-icon pt-15 text-justify">
                      <li>
                        <i className="fa fa-user ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          <strong>Dr. Monisha Chinthala</strong> - Student Lead
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          <strong>Dr. Ramya Rao</strong> - Deputy Student Lead
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          <strong>Dr. Bhoomika K</strong> - Joint Secretary
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          <strong>Dr. Ayush Mishra</strong> - Scientific
                          Director
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          <strong>Dr. Deepti MN</strong> - Outreach Director
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          <strong>Dr. Syed Taha</strong> - Editorial Director,
                          ‘Green Magazine’
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          <strong>Editorial Team Members:</strong> Dr. Lingaraju
                          Bijapur, Dr. Rashi - Activities Committee Member
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          <strong>Dr. Thulasi Patel</strong> - Outreach
                          Committee Member
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          <strong>Dr. Sushi Kadanakuppe</strong> - Faculty Lead
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          <strong>Dr. Suma N. K</strong> - Faculty Mentor
                        </span>
                      </li>
                      <li>
                        <i className="fa fa-user ttm-textcolor-skincolor" />
                        <span className="ttm-list-li-content">
                          <strong>Dr. Savitha Rao</strong> - Faculty Mentor
                        </span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default PlanetaryHealthStudentClub;
